import PaginationConfig from "@/entities/PaginationConfig";

const getNextOffset = (paginationConfig: PaginationConfig) => {
  const { page, limit} = paginationConfig;
  return page * limit - limit;
};

export {
  getNextOffset,
};